import { Injectable } from "@angular/core";
import { BrowserWindowService } from "apps-module/app/shared-library/services/environment/browser-window.service";
import { QueryStringSerializationService } from "apps-module/app/shared-library/services/environment/query-string-serialization.service";

import { FormSearchParametersModel } from "../models/form-search-parameters.model";
import { QuerySearchParametersModel } from "../models/query-search-parameters.model";

@Injectable()
export class QuerySearchParametersService {

    public constructor(
        private readonly _serializationService: QueryStringSerializationService,
        private readonly _browserWindowService: BrowserWindowService
    ) {
    }

    public set(searchParameters: FormSearchParametersModel): void {
        const queryParams = {
            pageNumber: searchParameters.pageNumber,
            searchText: searchParameters.searchText,
            fromDate: searchParameters.fromDate,
            toDate: searchParameters.toDate
        } as QuerySearchParametersModel;

        const queryString = this._serializationService.serialize(queryParams);

        this._browserWindowService.setQueryString(queryString);
    }
}
